import { render, staticRenderFns } from "./BuySpot.vue?vue&type=template&id=de556bfe&scoped=true&"
import script from "./BuySpot.vue?vue&type=script&lang=js&"
export * from "./BuySpot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de556bfe",
  null
  
)

export default component.exports